const asyncFormValidation = (values, dispatch, action, validation) => {
    return new Promise((resolve, reject) => {
        dispatch(action(values))
            .then((response) => {
                validation(values, response, resolve, reject);
	  });
    });
};

export default asyncFormValidation;